/**
 * Feste Pixel-Schriftgroessen im Slide-Text mit der Box mitwachsen lassen
 * (Jans Fund 17.09.2026, „Meseberg": riesiger Zeilenabstand im Vollbild-Viewer).
 *
 * Der Pro-Editor schreibt die Schriftgroesse als festen Pixelwert in den Text
 * (`font-size: 18px`). Die Box skaliert aber mit dem Bildschirm
 * (responsiveMultiplier: 1 / 2,11 / 3 — Innenabstand, Radius, Grundschrift).
 * Der feste Wert blieb klein, waehrend die Zeilenhoehe von der grossen
 * Grundschrift kam (gemessen: Text 18 px in 55,7-px-Zeilen). Die Box setzt
 * `--scrolly-box-skala`; ohne Variable (Faktor 1) bleibt es beim Original.
 * Idempotent: bereits umgerechnete Werte (calc …) werden nicht erneut gefasst.
 */
const PIXEL_SCHRIFT = /font-size:\s*([0-9]*\.?[0-9]+)px/gi;

export function pixelSchriftSkalieren(html: string): string {
    return html.replace(PIXEL_SCHRIFT, "font-size: calc($1px * var(--scrolly-box-skala, 1))");
}
